import { Injectable, inject } from "@angular/core";
import { Observable, MonoTypeOperatorFunction } from "rxjs";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";
import { AuthService } from "../auth";
import { delay as delayOperator, retryWhen, scan, tap } from "rxjs/operators";
import { Router } from "@angular/router";
@Injectable()
export class HttpHandlerInterceptor implements HttpInterceptor {
    private responseErrorHandlerService = inject(ResponseErrorHandlerService);
    private router = inject(Router);
    private authService = inject(AuthService);

    fatalErrors = [400, 401, 404, 409, 423, 429, 502];
    showBanner = true;

    constructor() {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.headers.get("showBanner") === "false") {
            this.showBanner = false;
            req.headers.delete("showBanner");
        } else {
            this.showBanner = true;
        }

        const clonedRequest = req.clone({
            headers: req.headers
                .set("Referrer-Policy", "strict-origin-when-cross-origin")
                .set(
                    "Permissions-Policy",
                    "geolocation=(), midi=(), notifications=(), push=(), sync-xhr=(), microphone=(), camera=(), magnetometer=(), gyroscope=(), speaker=(), vibrate=(), fullscreen=(), payment=()",
                ),
        });
        return next.handle(clonedRequest).pipe(this.retryWithDelay(clonedRequest, 5));
    }

    retryWithDelay<T>(req: HttpRequest<any>, count: number): MonoTypeOperatorFunction<T> {
        return (input) =>
            input.pipe(
                retryWhen((errors) =>
                    errors.pipe(
                        scan((acc, error) => ({ count: acc.count + 1, error }), {
                            count: 0,
                            error: undefined as any,
                        }),
                        tap((current) => {
                            if (!current.error.ok) {
                                if (current.error.status === 503) {
                                    // Maintenance
                                    this.authService.logout();
                                    this.router.navigate([this.router.url]);
                                } else if (this.fatalErrors.indexOf(current.error.status) > -1) {
                                    // We don't retry requests that are fatal, send error right away in popup form
                                    if (
                                        current.error.url.indexOf("connect/authorize") === -1 &&
                                        current.error.url.indexOf("negotiate") === -1 &&
                                        (current.error.url.indexOf("/cards") === -1 || current.error.status !== 404)
                                    ) {
                                        this.responseErrorHandlerService.responseErrorHandler(current.error);
                                    }
                                    if (current.error.status === 401 && current.error.url.indexOf("negotiate") === -1) {
                                        // SignalR token expired
                                        this.authService.signalRUnauthorizedEmitter.next(true);
                                    }
                                    throw current.error;
                                }
                            }
                            if (current.count > count) {
                                if (this.showBanner) {
                                    if (current.error.status === 0) {
                                        this.responseErrorHandlerService.showBanner({
                                            type: "lostConnection",
                                        });
                                    } else {
                                        this.responseErrorHandlerService.showBanner({
                                            error: current.error.error,
                                            type: "microService",
                                        });
                                    }
                                }
                                throw current.error;
                            }
                        }),
                        delayOperator(2 ** (6 - count) * 1000),
                    ),
                ),
            );
    }
}
